import {
  ICreateOutreachResult,
  IOutreachDetail,
  IOutreachListResponse,
  IOutreachTemplate,
  ICsvInspection,
} from '../types/outreach.types';
import { formDataInstance, instance } from './instance';

function responsePayload(response: { data: any }) {
  const body = response.data;

  return body && typeof body.statusCode === 'number' && 'data' in body
    ? body.data
    : body;
}

export const outreachApi = {
  getTemplate: async (id: number): Promise<IOutreachTemplate> => {
    const response = await instance.get(`/outreach/studio/templates/${id}`);
    return responsePayload(response);
  },
  inspectCsv: async (form: FormData): Promise<ICsvInspection> => {
    const response = await formDataInstance.post(
      '/outreach/studio/inspect',
      form
    );
    return responsePayload(response);
  },

  generateTemplate: async (
    brief: string,
    fields: string[],
    referenceHtml: string
  ): Promise<{ name: string; subject: string; html: string }> => {
    const response = await instance.post(
      '/outreach/studio/generate',
      { brief, fields, referenceHtml },
      { timeout: 100000 }
    );
    return responsePayload(response);
  },

  listTemplates: async (
    page: number
  ): Promise<{
    data: IOutreachTemplate[];
    page: number;
    totalPages: number;
  }> => {
    const response = await instance.get('/outreach/studio/templates', {
      params: { page },
    });
    return responsePayload(response);
  },

  saveTemplate: async (
    input: { name: string; subject: string; html: string; version?: number },
    id?: number
  ): Promise<IOutreachTemplate> => {
    const response = id
      ? await instance.put(`/outreach/studio/templates/${id}`, input)
      : await instance.post('/outreach/studio/templates', input);
    return responsePayload(response);
  },

  deleteTemplate: async (id: number): Promise<void> => {
    await instance.delete(`/outreach/studio/templates/${id}`);
  },

  createOutreach: async (
    formData: FormData
  ): Promise<ICreateOutreachResult> => {
    const response = await formDataInstance.post('/outreach/upload', formData);
    return responsePayload(response);
  },

  sendOutreach: async (
    id: number
  ): Promise<{ message: string; jobsCreated: number }> => {
    const response = await instance.post(`/outreach/${id}/send`);
    return responsePayload(response);
  },

  listOutreaches: async (
    page = 1,
    perPage = 20
  ): Promise<IOutreachListResponse> => {
    const response = await instance.get(
      `/outreach?page=${page}&perPage=${perPage}`
    );
    return response.data;
  },

  getOutreach: async (
    id: number,
    recipientPage = 1,
    recipientPerPage = 50
  ): Promise<IOutreachDetail> => {
    const response = await instance.get(
      `/outreach/${id}?recipientPage=${recipientPage}&recipientPerPage=${recipientPerPage}`
    );
    return responsePayload(response);
  },

  cancelOutreach: async (id: number): Promise<{ message: string }> => {
    const response = await instance.post(`/outreach/${id}/cancel`);
    return responsePayload(response);
  },

  retryOutreach: async (
    id: number
  ): Promise<{ message: string; jobsCreated: number }> => {
    const response = await instance.post(`/outreach/${id}/retry`);
    return responsePayload(response);
  },
};
